(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.azoraPriceQuantityHandlerBound) return;
    window.azoraPriceQuantityHandlerBound = true;

    const formatMoney = (cents, format) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(Math.round(cents), format);
      }

      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency
      }).format(cents / 100);
    };

    document.addEventListener('azora:quantity-or-mode-change', (event) => {
      const mode = event.detail?.mode === 'bulk' ? 'bulk' : 'sample';
      const quantity = Math.max(1, Number.parseInt(event.detail?.quantity || 1, 10));

      document.body.classList.toggle('azora-wholesale-active', mode === 'bulk');

      document
        .querySelectorAll(".azora-price-container[data-azora-main-price='true']")
        .forEach((container) => {
          const basePrice = Number(container.dataset.priceCents || 0);
          const wholesalePrice = Number(container.dataset.wholesalePriceCents || 0);
          const format = container.dataset.moneyFormat || '${{amount}}';
          const normalTotal = basePrice * quantity;
          const wholesaleTotal = wholesalePrice * quantity;

          container.querySelectorAll('.azora-normal-price').forEach((element) => {
            element.textContent = formatMoney(normalTotal, format);
          });

          container.querySelectorAll('.azora-wholesale-price').forEach((element) => {
            element.textContent = formatMoney(wholesaleTotal, format);
          });
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
